import { createHashRouter, createRoutesFromElements, Navigate, Route } from 'react-router';
import App from '../features/app/App';
import { routes } from './routes';
import RouteErrorFallback from '../components/RouteErrorFallback';
import { suspendPageLoad } from './suspendPageLoad';

const Assets = suspendPageLoad(() => import('../pages/Assets'));
const DeviceState = suspendPageLoad(() => import('../pages/EmbeddedDeviceState'));
const IotEvents = suspendPageLoad(() => import('../pages/EmbeddedIotEvents'));
const Rental = suspendPageLoad(() => import('../pages/EmbeddedRental'));

const routesFromElements = createRoutesFromElements(
    <Route element={<App />} errorElement={<RouteErrorFallback />}>
        <Route path={routes.ASSETS} element={<Assets />} />
        <Route path={routes.DEVICE_STATE} element={<DeviceState />} />
        <Route path={routes.IOT_EVENTS} element={<IotEvents />} />
        <Route path={routes.RENTAL} element={<Rental />} />
        <Route path='*' element={<Navigate to={routes.ASSETS} replace />} />
    </Route>
);

export const router = createHashRouter(routesFromElements);
